import { render } from "./RiProdoffering182.vue?vue&type=template&id=6b220d9e"
import script from "./RiProdoffering182.vue?vue&type=script&lang=js"
export * from "./RiProdoffering182.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering182.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b220d9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b220d9e', __exports__)) {
    api.reload('6b220d9e', __exports__)
  }
  
  module.hot.accept("./RiProdoffering182.vue?vue&type=template&id=6b220d9e", () => {
    api.rerender('6b220d9e', render)
  })

}


export default __exports__